import { useEffect, memo, Suspense } from 'react'
import { useMatches, useLocation, Outlet } from 'react-router-dom'
import { Loading } from 'mk-pc'
import { useAppStore } from '@/stores'
import { LayoutAside, LayoutHeader, LayoutMenu } from './components'
import './BasicLayout.scss'

/**
 * 基础布局
 */
const BasicLayout = memo(() => {
  const matches = useMatches() as any
  const { pathname } = useLocation()
  const { layout, setActivePaths } = useAppStore()

  // 监听路由变化，获取激活的导航
  useEffect(() => {
    const { handle } = matches.pop()

    if (!handle || !handle.code) {
      setActivePaths('')
      return
    }

    setActivePaths(handle.code)
  }, [pathname])

  return (
    <section className="basiclayout">
      <LayoutAside />
      <div className="basiclayout-container">
        <LayoutHeader isOpen={layout.showHeader} />
        <div className="basiclayout-container__content">
          <div className="basiclayout-container__content-menu">
            <LayoutMenu />
          </div>
          <div className="basiclayout-container__content-wrap">
            <Suspense fallback={<Loading />}>
              <Outlet />
            </Suspense>
          </div>
        </div>
      </div>
    </section>
  )
})

export default BasicLayout
